import styled from "styled-components";

export const GalleryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const GalleryGrid = styled.div`
    display: grid;
  grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    padding:0 16px 16px 16px;

      @media (max-width: 1050px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const GalleryImage = styled.img`
    width: 100%;
    height: auto; 
    aspect-ratio: 16/9;
    border-radius: 8px;
    object-fit: cover;
    transition: transform 0.3s ease;
    cursor: pointer;

    &:hover {
        transform: scale(1.03);
    }
`;

export const GalleryHeader = styled.h2`
  font-size: 48px;
  justify-content: center;
  color: #252525;
  text-align: center;

        @media (max-width: 768px) {
     font-size: 32px;
  }
`;

export const SubHeader = styled.h3`
    font-size: 24px;
    text-align: center;
    
        @media (max-width: 768px) {
        font-size: 18px;
}
`;